import { IpodIcon } from './IpodIcon';

/**
 * author: GreenTurtwig
 * id 63BFCC93-117D-45ED-8E42-4019C6D7B970
 * name ipod
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ipod.svg
 * tags
 */
export const AppleIpodIcon = IpodIcon;
export default AppleIpodIcon